import FilterBox from "./FilterBox";
import FilterSelect from "./FilterSelect";

const FilterItemSelect = ({ name, selected, onSelectChange }) => {

    const onClick = () => {
        if(onSelectChange) onSelectChange(!selected);
    }

    return (
        <div className="filter-item" onClick={onClick}>
            {selected ?
                <FilterSelect /> :
                <FilterBox />
            }
            <p>{name}</p>
        </div>
    )
}

export default FilterItemSelect;
